// Confirmación antes de acciones irreversibles: cualquier botón con
// data-confirm="mensaje" pide confirm() antes de dejar pasar el click
// (funciona con <button type="submit"> normal o dentro de un button_to).

export function initConfirmaciones() {
  document.addEventListener("click", (e) => {
    const el = e.target.closest("[data-confirm]")
    if (!el) return
    if (!window.confirm(el.dataset.confirm)) {
      e.preventDefault()
      e.stopPropagation()
    }
  })
}
